import { useEffect, useState } from "react"

export const KAKAO_LOCAL_CACHE_CHANGED_EVENT = "kakao-local-cache-changed"

export const useKakaoLocalCacheRevision = (poll = true) => {
  const [revision, setRevision] = useState(0)
  useEffect(() => {
    const refresh = () => setRevision(previous => previous + 1)
    window.addEventListener(KAKAO_LOCAL_CACHE_CHANGED_EVENT, refresh)
    const timer = poll ? window.setInterval(refresh, 30_000) : null
    return () => {
      window.removeEventListener(KAKAO_LOCAL_CACHE_CHANGED_EVENT, refresh)
      if (timer !== null) window.clearInterval(timer)
    }
  }, [poll])
  return revision
}
